<template>
  <div class="report-metric-tile pa-6">
    <div class="d-flex align-center ga-2">
      <v-icon
        v-if="icon"
        :icon="icon"
        color="primary"
        size="48"
        data-testid="report-metric-tile-icon"
      />
      <span class="big-number text-primary" data-testid="report-metric-tile-value">
        {{ formattedValue }}
      </span>
    </div>
    <div class="subtitle2 mt-1" data-testid="report-metric-tile-label">
      {{ label }}
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { ReportMetricValueFormat } from "@/constants/reports";
import { formatReportNumber, formatReportPercentValue } from "@/_helpers/reports";

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    format: {
      type: String as PropType<ReportMetricValueFormat>,
      default: ReportMetricValueFormat.NUMBER,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const formattedValue = computed(() =>
      props.format === ReportMetricValueFormat.PERCENT
        ? `${formatReportPercentValue(props.value)}%`
        : formatReportNumber(props.value)
    );

    return { formattedValue };
  },
});
</script>

<style scoped lang="scss">
.report-metric-tile {
  border: 1px solid rgb(var(--v-theme-indigo-faint));
  border-radius: 8px;
}
</style>
